import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@lt/components';

// Components:
import PaylatePopup from './PaylatePopup';

// Actions:
import {
  finishOrderAction,
  goToOrderPageAction,
} from '../../store/actions/order';

// Selectors:
import { getOrderIsFinished } from '../../store/selectors/order';
import { getIsRouteTransition } from '../../store/selectors/view';
import { getIsPaylate } from '../../../../store/payment/selectors';

// Contants:
import { REDIRECT_TO_ORDER_DELAY } from '../../store/constants/view';

const baseCls = 'checkout-order-success';

class OrderSuccess extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      countdown: REDIRECT_TO_ORDER_DELAY / 1000,
    };

    // eslint-disable-next-line max-len
    this.countdownTick = () =>
      this.setState((state) => ({
        countdown: Math.max(state.countdown - 1, 0),
      }));
    this.task = setInterval(this.countdownTick, 1000);
  }

  componentDidUpdate(prevProps) {
    const { isOrderFinished, isRouteTransition, finishOrder } = this.props;

    if (!isOrderFinished && !isRouteTransition && prevProps.isRouteTransition) {
      finishOrder();
    }
  }

  componentWillUnmount() {
    clearInterval(this.task);
  }

  render() {
    const { goToOrderPage, isPaylate } = this.props;
    const { countdown } = this.state;

    const text = isPaylate
      ? 'Отправили вам письмо со ссылкой на анкету для оформления рассрочки. \n\rБронирование начнется автоматически, как только рассрочка будет одобрена.'
      : 'Бронирование начнётся автоматически. Вы сможете следить \n\rза статусом на странице заказа в личном кабинете';

    return (
      <div>
        <div className="like-h2">Заказ успешно оформлен</div>
        <div className={`lt-paper ${baseCls}`}>
          <div className="lt-icon-success">
            <i className="lt-icon-success__check" />
          </div>
          <h2 className={`${baseCls}__title`}>
            {isPaylate ? `Заказ создан` : `Поздравляем! Заказ успешно оформлен`}
          </h2>
          <p>{text}</p>
          {!isPaylate && (
            <p>
              {`Вы автоматически будете перенаправлены на страницу заказа через ⏱${countdown} сек.`}
            </p>
          )}
          <Button
            className={`${baseCls}__submit`}
            primary
            onClick={goToOrderPage}
          >
            Перейти в личный кабинет
          </Button>
        </div>
        {isPaylate && <PaylatePopup />}
      </div>
    );
  }
}

OrderSuccess.propTypes = {
  finishOrder: PropTypes.func.isRequired,
  goToOrderPage: PropTypes.func.isRequired,
  isOrderFinished: PropTypes.bool.isRequired,
  isRouteTransition: PropTypes.bool.isRequired,
  isPaylate: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isOrderFinished: getOrderIsFinished(state),
  isRouteTransition: getIsRouteTransition(state),
  isPaylate: getIsPaylate(state),
});

const mapDispatchToProps = (dispatch) => ({
  finishOrder: () => dispatch(finishOrderAction()),
  goToOrderPage: () => dispatch(goToOrderPageAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderSuccess);
